import { FormInstanceGridRow } from "./form-instance-grid-row.model";

export class FormTemplateInstancesGridData {
    public canMoveAtLeastOneForm: boolean;                    
    public canCopyAtLeastOneForm: boolean;
    public canDeleteAtLeastOneForm: boolean;
    public canDeleteAtLeastOneFolder: boolean;
    public canCreateSubFolderInAtLeastOneFolder: boolean;
    public canCreateForm: boolean;
    public canReorderForms: boolean; // VNEXT-1666

    public results: FormInstanceGridRow[];  // from server
    public data: FormInstanceGridRow[];
    public Data: FormInstanceGridRow[];  // from server

    // Note:  the following property, 'resultsAsPlainObjects', must contain the data to be displayed by a template instance grid.
    public resultsAsPlainObjects: object[] = []; // results translated into plain JS objects needed by Kendo Grid by service code

    public canPerformAtLeastOneAction() {
        return this.canCopyAtLeastOneForm || this.canMoveAtLeastOneForm || this.canDeleteAtLeastOneForm || this.canCreateSubFolderInAtLeastOneFolder || this.canCreateForm;
    }
}
